import { render } from "./DataMapperInvocationAdmin.vue?vue&type=template&id=b0b83234&scoped=true"
import script from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"

import "./DataMapperInvocationAdmin.vue?vue&type=style&index=0&id=b0b83234&scoped=true&lang=css"
import "./DataMapperInvocationAdmin.vue?vue&type=style&index=1&id=b0b83234&lang=scss"
import "./DataMapperInvocationAdmin.vue?vue&type=style&index=2&id=b0b83234&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0b83234"]])

export default __exports__